import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledTitle = styled.h5`
  font-size: ${rem('16px')};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.black};
  margin-top: ${rem('32px')};
  margin-bottom: ${rem('16px')};
  text-align: left;
`;

export const StyledMainTitle = styled.h4`
  margin: ${rem('40px')} 0 0 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: 600;
`;

export const StyledWrapper = styled.div`
  width: 100%;
`;
export const StyledContainer = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex: 0 0 36.8%;
    padding: ${rem('16px')} ${rem('30px')} 0 ${rem('16px')};
    background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-basis: 37%;
  }
  width: 100%;
`;
